// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
export { TriggerConversionTracking } from '@neptune/analytics-feature';
export { pushToDataLayer, sendEventToGTM } from '@neptune/analytics-domain';
export {
  useCompareIsViewedAnalyticsEvent,
  useDashboardIsViewedAnalyticsEvent,
  useRunDetailsAreViewedAnalyticsEvent,
  useModelsTabIsViewedAnalyticsEvent,
  useModelDetailsAreViewedAnalyticsEvent,
  useProjectMetadataViewedAnalyticsEvent,
  useProjectMetadataDetailsViewEvent,
  useProjectsTabViewedEvent,
  useProjectViewedAnalyticsEvent,
  useUserInvitationAcceptedEvent,
  useTableViewViewedAnalyticsEvent,
  useReportIsViewedEvent,
  useRunsWereGroupedUsingGroupTags,
} from '@neptune/analytics-business-logic';
